import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';

import SwitchStats from '../shared/switch';
import CurrencySwitch from  '../shared/currency-switch';
import { getCurrencyIcon } from '../../../shared/js/get-currency-icon';
import { formatMoney } from '../shared/format';

import { browserHistory } from 'react-router';
import _toFinite from 'lodash/toFinite';

import Table from './components/table';
import Calendar from '../shared/calendar/main';
import PaymentForm from './components/payments-form';
import CategoriesFilter from './components/categories-filter';
import PointCategoriesFilter from './components/point-category-filter';
import PayoutSystemsFilter from './components/payout-systems-filter';

lessRequire('modules/finances/main.less');

const isRocket = process.env.CPA_ENV === 'rocket';

const pointsName = isRocket ? 'QUIDs' : 'Поинты';

const Main = renderViewsState(props => {
	const isCurrencyExchangeEnabled = window.globalConfig.isCurrencyExchangeEnabled &&
		(window.globalConfig.isCurrencyExchangeEnabled === true
	|| window.globalConfig.isCurrencyExchangeEnabled.includes(props.userId));
	const { intl } = props;
	const tableType = props.routes[props.routes.length-1].name;
	const switchStatsLinkConfig = [{
		className: 'header-switch__link-finances-history',
		title: 'История',
		url: 'finances/history/'
	}, {
		className: 'header-switch__link-finances-payouts',
		title: 'Выплаты',
		url: 'finances/payouts/'
	}, {
		className: 'header-switch__link-finances-history',
		title: 'Конвертации',
		url: 'finances/conversions/'
	}];
	const reselersIds = [ 159699, 161309, 168900, 144745 ];
	const showPoints = !reselersIds.includes(props.userId);
	!reselersIds.includes(props.userId) && (
		switchStatsLinkConfig.push({
			className: 'header-switch__link-points-history',
			title: pointsName,
			url: 'finances/points/'
		}));
	if (window.location.pathname.includes('finances/points') && reselersIds.includes(props.userId)) {
		browserHistory.push('/404');
	}
	const {start, end} = window.globalConfig.disabledHoursUTC;
	const getMskTimeString = hour => moment().utc().set({hour})
		.tz(isRocket ? 'Europe/Moscow' : 'Europe/Kiev')
		.format('HH');
	let convertationMessage = intl(`Конвертация недоступна с X:00 до Y:00 (MCК)`)
		.replace('X', getMskTimeString(start))
		.replace('Y', getMskTimeString(end));

	if (!isRocket) {
		convertationMessage = convertationMessage.replace('MCК', 'Kyiv');
	}

	const areRubTransactionsVisible = isRocket || props.data.hasRubHistory;
	const switchCurrenciesList = props.listOfCurrencies.filter(c => c.id !== 'rub' || areRubTransactionsVisible );

	return (
		<div className="finances-wrap container">

			{<div className="content-container payments-form-wrap">
				{isCurrencyExchangeEnabled && (<span className="convertation__massage">
					{convertationMessage}
				</span>)}
				<PaymentForm {...props}
					initialValues={props.formInitialValues}
					currencyBalances={props.currencyBalances}
					isCurrencyExchangeEnabled={isCurrencyExchangeEnabled}
					enableReinitialize={true}
				/>
			</div>}

			<div className="finances-wrap-total">
				<div className="finances-wrap-total__item total">
					<p>{props.intl('Итого за выбранный период')}</p>
				</div>
				{showPoints &&
					<div className="finances-wrap-total__item icon-points">
						<p className="finances-wrap-total__item-label">{props.intl(pointsName)}</p>
						<p className="finances-wrap-total__item-value">
							{_toFinite(Math.floor(props.totalData.points * 100)/100)}
						</p>
					</div>
				}
				<div className="finances-wrap-total__item icon-hold">
					<p className="finances-wrap-total__item-label">{props.intl('На холде всего')}</p>
					<p className="finances-wrap-total__item-value">
						{formatMoney(props.totalData.hold, true)} {getCurrencyIcon(props.activeCurrency)}
					</p>
				</div>
				<div className="finances-wrap-total__item icon-earned">
					<p className="finances-wrap-total__item-label">{props.intl('Заработано')}</p>
					<p className="finances-wrap-total__item-value">
						{formatMoney(props.totalData.approve, true)} {getCurrencyIcon(props.activeCurrency)}
					</p>
				</div>
				<div className="finances-wrap-total__item icon-income">
					<p className="finances-wrap-total__item-label">{props.intl('Начислено')}</p>
					<p className="finances-wrap-total__item-value">
						{formatMoney(props.totalData.income, true)} {getCurrencyIcon(props.activeCurrency)}
					</p>
				</div>
				<div className="finances-wrap-total__item icon-paid">
					<p className="finances-wrap-total__item-label">{props.intl('Выплачено')}</p>
					<p className="finances-wrap-total__item-value">
						{formatMoney(props.totalData.paid, true)} {getCurrencyIcon(props.activeCurrency)}
					</p>
				</div>
			</div>
			<div className="content-container content-container--no-margin">
				{!isRocket && <h2 className="font-proxima-nova-bold">{intl('Финансы')}</h2>}
				<div className="content-container__title">
					{isRocket && <h2 className="font-proxima-nova-bold">{intl('Финансы')}</h2>}
					<SwitchStats  links={switchStatsLinkConfig} intl={intl} />

					{ !isRocket && tableType === props.tableTypeEnum.history && (
						<div className="finances-wrap-position__currency">
							<CurrencySwitch
								listOfCurrencies={switchCurrenciesList}
								activeCurrency={props.activeCurrency}
								onSwitch={props.changeCurrency}/>
						</div>
					) }

					{tableType === props.tableTypeEnum.payouts && (
						<div className="payout-systems-position">
							<PayoutSystemsFilter
								options={props.payoutSystemsFilterData.options}
								initialValues={props.payoutSystemsFilterData.initialValue}
								enableReinitialize={false}
							/>
						</div>
					)}

					{[props.tableTypeEnum.history, props.tableTypeEnum.points].includes(tableType) && (
						<div className="calendar-position">
							<Calendar
								{...props.calendarData}
								onInit={props.calendarInit}
								onToggle={props.calendarToggle}
								onChange={props.calendarChange}
								onApply={d => {
									props.calendarApply(d);
									props.fetchData();
								}}
							/>
						</div>
					) }

					{ tableType === props.tableTypeEnum.history && (
						<div className="categories-position">
							<CategoriesFilter
								{ ...props }
								initialValues={ props.categoriesFilterData.initialValue }
								enableReinitialize={false} />
						</div>
					) }

					{ tableType === props.tableTypeEnum.points && (
						<div className='categories-position'>
							<PointCategoriesFilter
								{...props}
								initialValues={props.pointCategoriesFilterData.initialValue}
								enableReinitialize={false}
							/>
						</div>
					) }

				</div>
				<Table
					tableType={tableType}
					availableCurrencies={props.availableCurrencies}
					tableRows={props.dataTable(tableType).data}
					tableHeaders={props.tableHeaders(tableType)}
					sortByColumn={props.sortByColumn}
					columnSorting={props.columnSorting(tableType)}
					showMore={props.pagination().showMore}
					isCanNotMoveToNext={props.dataTable(tableType).isCanNotMoveToNext}
					tableTypeEnum={props.tableTypeEnum}
					intl={intl}
				/>
			</div>
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		currencyBalances: selectors.currencyBalances(state),
		userId: selectors.getUserId(state),
		tableTypeEnum: selectors.getTableTypeEnum,
		formInitialValues: selectors.getFormInitialValues(state),
		tableHeaders: selectors.getTableHeaders(state),
		paymentsFormData: selectors.getExchangeForm(state),
		exchangeData: selectors.getExchangeData(state),
		dataTable: selectors.getTableData(state),
		columnSorting: selectors.getColumnSorting(state),
		calendarData: selectors.getCalendar(state),
		progressBar: selectors.getProgressBar(state),
		listOfCurrencies: selectors.getListOfCurrencies(state),
		exchangeCurrencies: selectors.getListOfExchangeCurrencies(state),
		availableCurrencies: selectors.getListOfAvailableCurrencies(state),
		activeCurrency: selectors.getActiveCurrency(state),
		headerCurrency: selectors.getHeaderCurrency(state),
		totalData: selectors.getTotalData(state),
		payoutSystemsFilterData: selectors.getPayoutSystemsFilterData(state),
		categoriesFilterData: selectors.getCategoriesFilterData(state),
		pointCategoriesFilterData: selectors.getPointCategoriesFilterData(state),
		intl: selectors.getIntl(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/main.js